module.exports = __webpack_public_path__ + "static/media/poster.6da43c2b.png";